export default __webpack_public_path__ + "static/media/coinbase.6ae49cf0.png";